import { render, staticRenderFns } from "./returnedShow.vue?vue&type=template&id=4b66e6f2&scoped=true"
import script from "./returnedShow.vue?vue&type=script&lang=js"
export * from "./returnedShow.vue?vue&type=script&lang=js"
import style0 from "./returnedShow.vue?vue&type=style&index=0&id=4b66e6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66e6f2",
  null
  
)

export default component.exports